"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickEventArgs = void 0;
const EventType_1 = require("../EventType");
class TickEventArgs {
    constructor() {
        this.__type = EventType_1.EventType.Tick;
        this.__typeName = "Tick";
    }
}
exports.TickEventArgs = TickEventArgs;
